// Use serverNow (or the legacy Date header) to resume, then track elapsed page
// time with a monotonic clock. Without server time, start the full interval.
export function createExamDeadline(ticket, receivedAt, serverTime) {
  if (!ticket?.durationEnabled) return null;
  if (ticket.status === "expired") return receivedAt;
  const createdAt = Date.parse(ticket.createdAt);
  const expiresAt = ticket.expiresAt
    ? Date.parse(ticket.expiresAt)
    : createdAt + ticket.durationMinutes * 60000;
  const serverNow = Date.parse(serverTime);
  // HTTP Date has second precision; it can precede createdAt by milliseconds.
  const referenceTime = Number.isFinite(serverNow)
    ? Math.max(createdAt, serverNow)
    : createdAt;
  const remaining = expiresAt - referenceTime;
  return Number.isFinite(remaining) ? receivedAt + Math.max(0, remaining) : null;
}

export function getRemainingSeconds(deadline, now) {
  return deadline === null ? null : Math.max(0, Math.ceil((deadline - now) / 1000));
}
